import React, {useState} from 'react'
import { FaTimes } from 'react-icons/fa'
import YouTube from 'react-youtube'
import './movieVideos.css'
function MovieVideos({videoTrailer, playTrailer, stop}) {
    const [videoPlayer, setVideoPlayer] =useState(false)
    const newWay = videoTrailer.find((item) =>{
      return item.name==='Official Trailer' || 'YouTube'
    })

    const opts = {
        height: '300',
        width: '300',
        
    }
  return (
    <div>
        {playTrailer && <div className='video-wrapper'>
          <div className='wrapper-content'>
            <h5>Trailer</h5>
          <FaTimes className='close-trailer' onClick={stop}/>
          </div>
          {newWay ?
          <YouTube videoId={newWay.key} 
            opts={opts} 
            key={newWay.id} 
          />: <h2>no trailer</h2>}
            
    </div>}
    </div>
  )
}

export default MovieVideos